export default __webpack_public_path__ + "static/media/joni-bw.bf42247e.jpg";